<template>
  <section class="w-full md:px-3">
    <div>
      <p class="mb-2 text-[0.95rem] font-normal leading-tight">
      {{ translate('write about your experiences, your industry or your skills. Also talk about your previous jobs','ucfirst')}}.
      </p> 
    </div>
      <form @submit.prevent="JSON.stringify(props.presentationToUpdate) != '{}'
            ? updatePresentation() 
            : addNewPresentation()" 
            class="grid grid-cols-12 gap-4 text-base font-normal"> 
        <span class="col-span-12"> 
          <TextArea v-model.trim="value"    
            class="w-full h-40 xl:h-48 px-3 py-2 mt-2.5 rounded-md border border-iron" />
            <span class="flex justify-between items-center">
              <small>{{ errors.presentation_text || '&nbsp;' }}</small> 
              <p style="font-size: 0.96rem">{{ countedChar }}/{{ fieldCharNumber.max }}</p> 
            </span>
        </span>   
        <span class="col-span-12"> 
          <Button type="submit"
            :label="JSON.stringify(props.presentationToUpdate) != '{}'
            ? translate('update', 'ucfirst') 
            : translate('save', 'ucfirst')" 
            class="text-white px-5 py-2 float-right rounded-full bg-sea-serpent" />
        </span>
      </form> 
      <LoadingDialog :visible="isLoading" />
  </section>
</template>

<script setup>
import { ref, watch, onMounted } from "vue"
import TextArea from "primevue/textarea"
import Button from "primevue/button"
import { useToast } from "primevue/usetoast";
import { showToast } from "@/composables/toast";
import { translate } from "@/composables/translate";
import utils from "@/composables/utils";
import requestHandler from "@/composables/requestHandler";
import LoadingDialog from "@/components/Utils/LoadingDialog.vue";
import { useField, useForm } from 'vee-validate'; 
import { toTypedSchema } from "@vee-validate/yup";
import { object, string } from 'yup';
 

let toast = useToast(); 
let isLoading = ref(false)
let countedChar = ref(0)
let fieldCharNumber = ref({
  min: 50,
  max: 3000,
})

const props = defineProps({
    presentationToUpdate: {
        type: String,
        required: false,
        default: ''
    }
  });
  const emit = defineEmits(['closeModal','presentationUpdated'])


// ############ Validação formulário ############


 const { handleSubmit, resetForm, errors, setValues } = useForm({
   validationSchema: toTypedSchema(
     object({
       presentation_text: string().required(
         translate('this field is required', 'ucfirst')
       ).min(fieldCharNumber.value.min,
       translate('presentation field must be at least 50 characters', 'ucfirst')
       ).max(fieldCharNumber.value.max,
       translate('presentation field must be at most 3000 characters', 'ucfirst')
       ).ensure().trim().default('')
     })
   )
 });

 let { value, meta } = useField('presentation_text', undefined, {
  syncVModel: 'presentation_text',
});

 
// ############ Criação de Métodos/Funções ############ 


let addNewPresentation = handleSubmit(async(values) => { 

  if (values) {  
    isLoading.value = !isLoading.value
    const response = await requestHandler.executeRequest(`/api/curriculum/apresentation/create`, { presentation_text: values.presentation_text }, 'post');
    
    isLoading.value = !isLoading.value
 
    if (!response.success) {
      showToast(toast, translate('there was an error adding your presentation', 'ucfirst'), 'warn');
      return
    }
    showToast(toast, translate('your presentation was added', 'ucfirst'));
    emit('closeModal', false)
    resetForm()
    
  }
})

 let updatePresentation = handleSubmit(async(values) => {

   if (values && meta.dirty) {  
     isLoading.value = !isLoading.value
     const response = await requestHandler.executeRequest(`/api/curriculum/apresentation/update`, { presentation_text: values.presentation_text }, 'put');
    
     isLoading.value = !isLoading.value
 
     if (!response.success) {
       showToast(toast, translate('there was an error updating your presentation', 'ucfirst'), 'warn');
       return
     }
     showToast(toast, translate('your presentation was updated', 'ucfirst'));
     emit('closeModal', false)
     emit('presentationUpdated', true)
     resetForm()

   }
 })

watch(() => value.value, (newValue) => {
  countedChar.value = utils.countCharacters(newValue)
});

  onMounted(()=> {
    if (JSON.stringify(props.presentationToUpdate) != '{}') {
      setValues({
        presentation_text: props.presentationToUpdate.presentation_text
      });
    } 
  });
</script>